"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var add_client_integration_1 = require("../../../../../../api/calls/client/add_client_integration");
var constants_1 = require("../../../../../../constants/constants");
var validateForm_1 = require("../../../../../../helpers/validateForm/validateForm");
var client_1 = require("../../../../../../reducers/slices/client/client");
var get_client_thunk_1 = require("../../../../../../reducers/slices/client/thunks/get_client_thunk");
var main_1 = require("../../../../../../reducers/slices/main");
var AddGoogleCDN = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedClientIntegration = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).selectedClientIntegration;
    var data = selectedClientIntegration.data, _id = selectedClientIntegration._id;
    var _a = (0, validateForm_1.validateForm)(data), errors = _a.errors, isValid = _a.isValid;
    (0, react_2.useEffect)(function () {
        var _a = data || {}, service_account = _a.service_account, bucket_name = _a.bucket_name, cdn_domain_name = _a.cdn_domain_name;
        setFormData({ bucket_name: bucket_name, cdn_domain_name: cdn_domain_name, service_account: service_account });
    }, [data]);
    var showLoader = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Please Wait...",
            content: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Loading..." }),
        }));
    };
    var handleResponse = function (response) {
        if (response.success) {
            dispatch((0, main_1.setContentModal)({ title: "Success", content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: response.message }) }));
            dispatch((0, get_client_thunk_1.get_client_thunk)());
        }
        else {
            dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: response.message }) }));
        }
    };
    var setFormData = function (value) {
        (0, client_1.setSelectedClientIntegration)(__assign(__assign({}, selectedClientIntegration), { data: __assign(__assign({}, data), value) }));
    };
    var _onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var type, data_1, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    showLoader();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    type = selectedClientIntegration.type, data_1 = selectedClientIntegration.data;
                    return [4 /*yield*/, (0, add_client_integration_1.add_client_integration)({ type: type, data: data_1 })];
                case 2:
                    response = _a.sent();
                    handleResponse(response);
                    return [3 /*break*/, 4];
                case 3:
                    dispatch((0, main_1.setContentModal)(null));
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-8" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "gap-4" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Bucket Name", type: "text", required: true, value: (data === null || data === void 0 ? void 0 : data.bucket_name) || "", onValueChange: function (bucket_name) { return setFormData({ bucket_name: bucket_name }); } }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "CDN domain name", type: "text", required: true, value: (data === null || data === void 0 ? void 0 : data.cdn_domain_name) || "", onValueChange: function (cdn_domain_name) { return setFormData({ cdn_domain_name: cdn_domain_name }); } }), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("input", { type: "file", name: "Service Account Credentials", onChange: function (file) {
                                    var reader = new FileReader();
                                    reader.onload = function (e) {
                                        var text = e.target.result;
                                        var json = JSON.parse(text);
                                        if (!(json === null || json === void 0 ? void 0 : json.client_id) || !(json === null || json === void 0 ? void 0 : json.private_key) || !(json === null || json === void 0 ? void 0 : json.client_email)) {
                                            dispatch((0, main_1.setMessageModal)({ title: "Error", messages: ["Invalid Service Account Credentials file. Please upload a valid file."] }));
                                            return;
                                        }
                                        setFormData({
                                            service_account: {
                                                project_id: json.project_id,
                                                client_id: json.client_id,
                                                private_key: json.private_key,
                                                client_email: json.client_email,
                                            },
                                        });
                                    };
                                    reader.readAsText(file.target.files[0]);
                                } }) })] })) })), (0, jsx_runtime_1.jsx)("div", { className: "flex justify-center" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "w-40" }, { children: (0, jsx_runtime_1.jsx)(react_1.Button, __assign({ color: "primary", onClick: _onSubmit }, { children: !_id ? "Connect" : "Update" })) }))] })));
};
exports.default = AddGoogleCDN;
